function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

//
import * as React from 'react';
import { color } from "../../styles/theme";
import { apiStatusPropType, API_BEFORE_SEND } from "../../constants/sharedConstants";
import { SvgLoaderSignal, SvgCheckSolid, SvgCircleWarning } from "../../svg";
/**
 * A simple icon that can show api related variations
 * Can be used to composed with other components such as FileUploader
 */

export default function ApiIcon(_ref) {
  var _ref$apiStatus = _ref.apiStatus,
      apiStatus = _ref$apiStatus === void 0 ? API_BEFORE_SEND : _ref$apiStatus,
      children = _ref.children,
      isThemeDark = _ref.isThemeDark,
      rest = _objectWithoutProperties(_ref, ["apiStatus", "children", "isThemeDark"]);

  var propsToPassDown = _objectSpread({
    isThemeDark: isThemeDark
  }, rest);

  var childrenConfig = {
    API_BEFORE_SEND: children,
    API_IN_PROGRESS: React.createElement(SvgLoaderSignal, _extends({
      color: isThemeDark ? color.white : color.white
    }, propsToPassDown)),
    API_SUCCESS: React.createElement(SvgCheckSolid, _extends({
      color: color.success
    }, propsToPassDown)),
    API_ERROR: React.createElement(SvgCircleWarning, _extends({
      color: color.danger
    }, propsToPassDown))
  };
  return childrenConfig[apiStatus];
}
ApiIcon.propTypes = {
  apiStatus: apiStatusPropType
};